// Export all API services and types
export * from './config';
export * from './types';

// Services
export { ContentService } from './services/contentService';
export { AnalyticsService } from './services/analyticsService';
export { AuthService } from './services/authService';
export { SettingsService } from './services/settingsService';
export { FleetService } from './services/fleetService';
export { SystemService } from './services/systemService';
export { TagService } from './services/tagService';
export type { ServiceHealth, SystemHealthResponse, ProcessingApiHealth } from './services/systemService';
export type { Tag, TagsResponse } from './services/tagService';

// Utility functions
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};

export const getFileExtension = (filename: string): string => {
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
};

export const validateFileType = (file: File, allowedTypes: string[]): boolean => {
  return allowedTypes.includes(file.type) || 
    allowedTypes.some(type => file.name.toLowerCase().endsWith(type));
};

export const validateFileSize = (file: File, maxSize: number): boolean => {
  return file.size <= maxSize;
};

export const isVideoFile = (file: File | { type: string; name: string }): boolean => {
  return file.type.startsWith('video/') ||
    ['.mp4', '.mov', '.webm', '.avi', '.mkv', '.m4v'].some(ext =>
      file.name.toLowerCase().endsWith(ext)
    );
};

export const isAudioFile = (file: File | { type: string; name: string }): boolean => {
  return file.type.startsWith('audio/') ||
    ['.mp3', '.wav', '.flac', '.aac', '.ogg', '.m4a'].some(ext =>
      file.name.toLowerCase().endsWith(ext)
    );
};